import { BLACK } from '@styles/colors';
import { INTER } from '@styles/fonts';
import styled from 'styled-components';

// Styled Components
export const KeyboardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(4, 1fr);
  row-gap: 2vh;
  column-gap: 3vh;
  width: 100%;
`;

export const KeyButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 85%;
  height: 6vh;
  aspect-ratio: 5 / 3;
  background-color: #F7F7F7;
  justify-self: center;
  border: none;
  min-height: 32px;
  border-radius: 10px;
  font-family: ${INTER.bold};
  color: ${BLACK};
  font-size: 1.4rem;
  cursor: pointer;
  transition: background-color 0.15s;
  user-select: none;
  padding: 0; /* Remove default padding */
  margin: 0; /* Remove default margin */

  &:hover {
    background-color: #e5e5e5;
  }

  &:active {
    background-color: #d9d9d9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

// Empty cell styling
export const EmptyCell = styled.div`
  /* This keeps the grid structure intact */
`;

// Arrow SVG component for delete button
export const ArrowIcon = () => (
  <svg width="21" height="10" viewBox="0 0 21 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.5 9L1.5 5M1.5 5L5.5 1M1.5 5L19.5 5" stroke="#120058" strokeOpacity="0.7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.5 9L1.5 5M1.5 5L5.5 1M1.5 5L19.5 5" stroke="#000626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
